// extracted by mini-css-extract-plugin
export default {"glossaryContainer":"EsgGlossary_glossaryContainer__lfHoG","glossaryBtn":"EsgGlossary_glossaryBtn__TzdUw"};